//订单过滤器

/**
 * @description 支付状态
 */
export function paidFilter(status) {
  var statusMap = {
    true: '已支付',
    false: '未支付'
  };
  return statusMap[status];
}

/**
 * @description 订单状态
 * 2,已收货，待评价
 */
export function orderStatusFilter(status) {
  var statusMap = {
    '0': '未开奖',
    '1': '已中奖',
    '2': '未中奖',
    '4': '已取消'
  };
  return statusMap[status];
}
export function orderStatusTagFilter(status) {
  var statusMap = {
    '0': 'info',
    '1': 'success',
    '2': 'danger',
    '4': 'warning'
  };
  return statusMap[status];
}

/**
 * @description 退款状态
 * 2,已收货，待评价
 */
export function refundStatusFilter(status) {
  var statusMap = {
    '0': '未退款',
    '1': '申请中',
    '2': '已退款',
    '3': '退款中'
  };
  return statusMap[status];
}